import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var FilledArrowDown = function (props) { return (React.createElement(Icon, __assign({ width: "20px", height: "20px", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
        React.createElement("path", { d: "M9.01118 13.6095C9.55783 14.1302 10.4456 14.1302 10.9922 13.6095L16.5899 8.27828C16.9922 7.89509 17.1103 7.32448 16.8916 6.82468C16.673 6.32487 16.1657 6 15.5972 6L4.40185 6.00417C3.83771 6.00417 3.32605 6.32904 3.10739 6.82884C2.88873 7.32865 3.01118 7.89926 3.40914 8.28244L9.0068 13.6137L9.01118 13.6095Z", fill: "currentColor" })))); };

export { FilledArrowDown as default };
//# sourceMappingURL=FilledArrowDown.js.map
